export default time => new Promise(resolve => setTimeout(resolve, time))



// WEBPACK FOOTER //
// ./src/App/helpers/sleep.js